import moduleReducer from "./reducers";

export default moduleReducer;